import React from "react";
import "./TriggersCard.css";
// import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { useState } from "react";
import ContactTriggerDetails from "../Contacts/ContactTriggerDetail";
import { Drawer } from "@material-ui/core";


function MediaCard4(props) {

  const [openPoup, SetOpenPopup ] = useState(false);
  const [userid, SetUserid ] = useState(0);
 
  const formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };

const onNameClick = (side, open, row) => event => {

      SetOpenPopup (true);
      SetUserid (row.contactid)
  
    }
  const rows = props.DashboardData[8];

  return rows.map(row => (
    <div className="item">
      <div className="detail-box">
        <h3 className="name" component="th"
                  scope="row"  style={{ cursor: "pointer" }}
                  onClick={onNameClick("openDetails", true,  row )}>
                    
                    {row.name} </h3>
        <div className="address-text">
          {row.position !== null && row.position !== "" ? row.position+"," : ""} {" "}
          {row.location !== null ? row.location : ""}
        </div>

    

        <div className="date-info">
          {row.campaign !== null ? row.campaign : ""},{" "}
          {row.triggerdata !== null ? row.triggerdata : ""}
          
        </div>

        <div className="date-info">
          {" "}
          Date {row.date !== null ? formatDate(row.date) : ""}
        </div>
        <div className="stage-text">
          {row.triggerstatus !== null ? row.triggerstatus : ""}
        </div>
        <div className="stage-text-detail">
          <span>
          {row.company !== null ? row.company : ""}, {row.linkedinprofile !== null ? row.linkedinprofile : ""}, {row.campaign !== null ? row.campaign : ""}
          </span>
        </div>
      </div>

      {row.contactid == userid && (    
<Drawer
        anchor="right"
        open={openPoup}
      >
        <ContactTriggerDetails
        
            Close={() => SetOpenPopup (false)}
             details={row}
            Campaignid={row.campaignid}
          id={row.contactid}
          triggerid={row.triggerid}
          heading={"Trigger Details"}
        />
      </Drawer>
        )}
    </div>
  ));

  function onClickCard(currentHeader) {
    props.onClickCard(currentHeader);
  }
}


const mapDispatchToProps = dispatch => {
 
  return {
    onHandleCampaign: data =>
      dispatch({
        type: "Campaign_Detail",
        payload: data
      })
  };
};
export default connect(null, mapDispatchToProps)(MediaCard4);
